
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ClientHistoryTab } from "./tabs/ClientHistoryTab";
import { ClientSubscriptionsTab } from "./tabs/ClientSubscriptionsTab";
import { ClientDetailsTab } from "./tabs/ClientDetailsTab";
import { AllowedCoursesSelector } from "./AllowedCoursesSelector";
import { useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Client } from "@/types/types";

interface ClientDetailsTabsProps {
  client: Client;
  isLoading?: boolean;
  paymentsBySubscription : Record<string, any[]>;
  onUpdate?: () => void;
}

export function ClientDetailsTabs({ client, isLoading = false, paymentsBySubscription, onUpdate }: ClientDetailsTabsProps) {
  const { t } = useTranslation("adminui3");
  const [activeTab, setActiveTab] = useState("history");

  const handleTabChange = useCallback((value: string) => {
    setActiveTab(value);
  }, []);

  // Remove the console.log that was causing a re-render
  
  return (
    <Tabs defaultValue={activeTab} value={activeTab} onValueChange={handleTabChange}>
      <TabsList className="mb-4">
        <TabsTrigger value="history">{t("clientDetailsTabs.history")}</TabsTrigger>
        <TabsTrigger value="subscriptions">{t("clientDetailsTabs.subscriptions")}</TabsTrigger>
        <TabsTrigger value="details">{t("clientDetailsTabs.details")}</TabsTrigger>
        <TabsTrigger value="courses">{t("clientDetailsTabs.allowedCourses")}</TabsTrigger>
      </TabsList>
      
      <TabsContent value="history">
        <ClientHistoryTab />
      </TabsContent>
      
      <TabsContent value="subscriptions">
        <ClientSubscriptionsTab client={client} paymentsBySubscription={paymentsBySubscription} />
      </TabsContent>
      
      <TabsContent value="details">
        <ClientDetailsTab client={client} isLoading={isLoading} />
      </TabsContent>
      
      <TabsContent value="courses">
        <AllowedCoursesSelector 
          userId={client.id} 
          currentAllowedCourses={client.allowed_courses}
          onUpdate={onUpdate}
        />
      </TabsContent>
    </Tabs>
  );
}
